import React, { useState } from 'react';
import UserSelect from '../../components/UserSelect';
import UserDetails from '../../components/UserDetails';

const UsersPage = () => {
    const [selectedUserId, setSelectedUserId] = useState('');

    return (
        <div className="p-6 space-y-6 max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-800 mb-6">Users Management</h1>
            
            <div className="bg-white p-6 rounded-lg shadow">
                <label className="block text-gray-700 font-medium mb-2">
                    Select User
                </label>
                <UserSelect 
                    value={selectedUserId} 
                    onChange={setSelectedUserId}
                />
            </div>

            {selectedUserId && (
                <UserDetails userId={selectedUserId} />
            )}
        </div>
    );
};

export default UsersPage;
